<template>
  <div class="DatePicker">
    <mt-datetime-picker
      v-model="pickerValue"
      ref="picker"
      type="date"
      @confirm="handleConfirm"
      :startDate="new Date(1920, 1, 1)"
      :endDate="new Date()"
    >
    </mt-datetime-picker>
    <div class="DatePickerPlacehoulder" v-if="!value" @click.stop="openPicker">{{
        $t('lang.DatePicker.Placehoulder')
      }}
    </div>
    <div class="value" v-else>{{ value }}</div>
    <div v-if="PickerShow" class="mask"></div>
  </div>
</template>

<script>
export default {
  name: 'index',
  props: ['value'],
  data () {
    return {
      pickerValue: new Date(),
      PickerShow: false
    }
  },
  watch: {
    '$store.state.locale': function () {
      if (this.$refs.picker.visible) {
        this.cancelPicker()
        this.openPicker()
      }
    }
  },
  methods: {
    openPicker () {
      if (!this.$refs.picker.visible) {
        this.$refs.picker.open()
        this.createSelfPicker()
        this.PickerShow = true
      }
    },
    createSelfPicker () {
      const newDiv = document.createElement('div')
      const newDiv1 = document.createElement('div')
      newDiv.className = 'DatePickerSelf'
      newDiv1.className = 'operateBox'
      newDiv.innerHTML = `
       <div class="DatePickerTitle">${this.$t('lang.DatePicker.title')}</div>
       <div class="DateColumn">
              <div class="DateItem1">${this.$t('lang.DatePicker.DateCloumn')[0]}</div>
          <div class="DateItem2">${this.$t('lang.DatePicker.DateCloumn')[1]}</div>
          <div class="DateItem3">${this.$t('lang.DatePicker.DateCloumn')[2]}</div>
       </div>
      `
      newDiv1.innerHTML = `
            <div class="operate">
          <div class="Cancel" id="cancelPicker" >${this.$t('lang.DatePicker.Cancel')}</div>
          <div class="Confirm" id="confirmPicker">${this.$t('lang.DatePicker.Confirm')}</div>
        </div>
      `
      // 查找具有 .mint-popup 类的元素
      const mintPopup = this.$el.querySelector('.mint-popup')

      // 如果找到了具有 .mint-popup 类的元素，则在其下面追加新 div
      if (mintPopup) {
        mintPopup.appendChild(newDiv)
        mintPopup.appendChild(newDiv1)
      } else {

      }
      const cancelPicker = newDiv1.querySelector('#cancelPicker')
      const confirmPicker = newDiv1.querySelector('#confirmPicker')
      let self = this
      cancelPicker.addEventListener('click', function () {
        self.cancelPicker()
      })
      confirmPicker.addEventListener('click', function () {
        self.confirmPicker()
      })
    },
    destroySelfPicker () {
      const mintPopup = this.$el.querySelector('.mint-popup')
      const datePickerSelf = mintPopup.querySelector('.DatePickerSelf')
      const operateBox = mintPopup.querySelector('.operateBox')

      // 移除事件监听器
      const cancelPicker = operateBox.querySelector('#cancelPicker')
      const confirmPicker = operateBox.querySelector('#confirmPicker')
      cancelPicker.removeEventListener('click', this.cancelPicker)
      confirmPicker.removeEventListener('click', this.confirmPicker)

      // 移除节点
      if (datePickerSelf && datePickerSelf.parentNode) {
        datePickerSelf.parentNode.removeChild(datePickerSelf)
      }
      if (operateBox && operateBox.parentNode) {
        operateBox.parentNode.removeChild(operateBox)
      }
    },
    confirmPicker () {
      this.$refs.picker.confirm()
      this.PickerShow = false
    },
    cancelPicker () {
      this.PickerShow = false
      this.destroySelfPicker()
      this.$refs.picker.close()
    },
    // 确认事件回调
    handleConfirm (value) {
      this.$emit('getDate', convertToYYYYMMDD(value))

      function convertToYYYYMMDD (dateString) {
        const date = new Date(dateString)
        const year = date.getFullYear()
        const month = (date.getMonth() + 1).toString().padStart(2, '0')
        const day = date.getDate().toString().padStart(2, '0')
        return `${day}-${month}-${year}`
      }
    }
  }
}
</script>

<style scoped lang="less">

.DatePicker {
  height: 100%;
  width: 100%;

}

.DatePickerPlacehoulder {
  color: #404040;
  cursor: pointer;
}

.value {
  color: rgb(246, 217, 170);
}

/deep/ .mint-popup {
  border-radius: 4.16vw 4.16vw 0vw 0vw;
  //height: 112vw;
  padding: 5vw;
  background: #232325;
  //background: #fff;
  //position: relative;
  width: 100vw;
  //top: 28vw;
  padding-bottom: 10vw;
  //height: 120vw;
  position: fixed;
  bottom: 0;
  width: 100%;
}

/deep/ .picker-items {
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding: 0;
  text-align: right;
  font-size: 24px;
  position: relative;
  flex-direction: row-reverse; /* 添加这一行来颠倒子元素的顺序 */
  margin-bottom: 20vw;
  color: #7C7C7C;
  border-radius: 4.16vw;
  background: #181818;
  position: relative;
  top: 11vw;
  font-size: 1rem;
  //max-height: 50vw;
  .picker-selected {
    color: #FFFFFF;
    border: none;
  }
}

/deep/ .picker-toolbar {
  display: none;
  border: none;
  position: fixed;
  top: 95vw;
}

/deep/ .mint-datetime-cancel {
  height: 9.72vw;
  width: 41.11vw;
  border: 1px solid #BEBEBE;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.83vw;
  font-size: 4.16vw;
  color: #C5C3C3;
}

/deep/ .mint-datetime-confirm {
  margin-left: 4vw;
  height: 9.72vw;
  width: 41.11vw;
  background: #F6D9AA;
  border-radius: 0.83vw;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000000;
  font-size: 4.16vw;
}

/deep/ .mint-datetime-picker {
  padding-bottom: 4vw;
}

/deep/ .v-modal {
  pointer-events: none;
}

/deep/ .DatePickerSelf {
  position: absolute;
  top: 0vw;

  .DatePickerTitle {
    z-index: 9999;
    font-weight: 700;
    color: #F6D9AA;
    position: relative;
    left: 45vw;
    top: 4vw; // 假设这是居中的位置，具体数值需要根据实际布局调整
    transform: translate(-50%, -50%); // 使用transform进行居中
    font-size: 4.72vw; // 可以考虑使用em或rem单位
  }

  .DateColumn {
    width: 84vw;
    display: flex;
    justify-content: space-around;
    z-index: 9999;
    font-weight: 500;
    position: relative;
    left: 46vw;
    top: -4.5vw; // 假设这是想要的位置，具体数值需要根据实际布局调整
    transform: translateX(-50%); // 仅水平居中
    font-size: 4.44vw; // 可以考虑使用em或rem单位

    .DateItem1 {
      flex: 1;
      text-align: center;
      position: relative;
      left: -2vw;
    }

    .DateItem2 {
      flex: 1;
      text-align: center;
    }

    .DateItem3 {
      flex: 1;
      text-align: center;
    }

  }

}

/deep/ .operateBox {
  .operate {
    width: 84vw;
    height: 13vw;
    position: absolute;
    z-index: 9999;
    //border: 1px solid red;
    display: flex;
    justify-content: space-around;
    align-items: center;
    left: 50vw;
    top: 83%; // 假设这是想要的位置，具体数值需要根据实际布局调整
    transform: translateX(-50%); // 仅水平居中
    .Cancel {
      height: 9.72vw;
      width: 41.11vw;
      border: 1px solid #BEBEBE;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 0.83vw;
      font-size: 4.16vw;
    }

    .Confirm {
      margin-left: 4vw;
      height: 9.72vw;
      width: 41.11vw;
      background: #F6D9AA;
      border-radius: 0.83vw;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #000000;
      font-size: 4.16vw;
    }
  }

}
.mask{
  height: 100vw;
  width: 100vw;
  background: transparent;
  position: fixed;
  top: 0vw;
  left: 0vw;
}
</style>



// WEBPACK FOOTER //
// src/components/DatePicker/index.vue